module.exports = __webpack_public_path__ + "img/owners-association.3a29aa44.svg";